<h1 style="text-align: center;">Institutional Session</h1>
<h2>Description</h2>
<p>
    The Institutional Session of CIFRIS24 brings together key stakeholders from the cryptography and cybersecurity
    sectors. This session provides a unique platform for institutional and industrial leaders to discuss the latest
    advancements, challenges, and strategic directions in the field. Attendees will gain insights into current trends
    and future developments, fostering collaboration between academia, industry, and government entities. Through a
    series of keynote addresses, panel discussions, and networking opportunities, the Institutional Session aims to
    strengthen the ties between research and practical applications, ensuring the continuous evolution and security of
    cryptographic practices.
</p>
<h2>Program</h2>
<p>
    <i> September 27th, workshop session</i>
    <br>
    <i> Main Hall, 10:00 - 13:20</i>
</p>
<app-orari-institutional-session24></app-orari-institutional-session24>